<template>
	<el-container class="friend-page">
		<el-aside width="100%" class="friend-list-box">
			<div class="friend-list-header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<el-scrollbar class="friend-list-items">
				<div v-for="(friends, i) in friendValues" :key="i">
					<div class="index-title">{{ friendKeys[i] }}</div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</el-aside>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		HeadImage

	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {},
			activeFriend: {}
		}
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.$store.commit("setActiveFriend", friend);
			this.loadUserInfo(friend.id);

			// VSCode环境中，同时打开编辑器中的聊天窗口
			if (window.vscodeServices) {
				console.log('[InboxFriend] 在VSCode环境中打开好友编辑器');
				try {
					const panelManagerService = window.vscodeServices.get('panelManagerService');
					if (panelManagerService && panelManagerService.openChatEditor) {
						// 构造用户信息对象，适配openChatEditor所需的格式
						const chatUser = {
							id: friend.id,
							nickName: friend.nickName,
							name: friend.nickName,
							headImage: friend.headImage,
							headImageThumb: friend.headImageThumb || friend.headImage,
							avatar: friend.headImage
						};

						panelManagerService.openChatEditor(chatUser);
						console.log('[InboxFriend] ✅ 好友编辑器已打开:', chatUser.nickName);
					} else {
						console.warn('[InboxFriend] ⚠️ PanelManagerService或openChatEditor方法不可用');
					}
				} catch (error) {
					console.error('[InboxFriend] ❌ 打开好友编辑器失败:', error);
				}
			}
		},
		onDelFriend(friend) {
			this.$confirm(`确认删除'${friend.nickName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
					this.$message.success("删除好友成功");
					this.$store.commit("removeFriend", friend.id);
					this.$store.commit("removePrivateChat", friend.id);
				})
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online
				}
				this.$store.commit("addFriend", friend);
			})
		},
		async onSendMessage(user) {
			// 构造聊天数据
			let chatData = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImageThumb,
			};

			// 打开聊天会话
			this.$store.commit("openChat", chatData);

			// 查找会话索引
			const chatIndex = this.$store.getters.findChatIdx(chatData);
			if (chatIndex !== undefined && chatIndex !== -1) {
				// 激活会话
				this.$store.commit("activeChat", chatIndex);

				// 在VSCode环境中，需要同步到统一会话服务并通知编辑器面板
				if (window.vscodeServices) {
					console.log('[InboxFriend] 在VSCode环境中，同步并激活编辑器面板会话');
					try {
						// 获取当前激活的会话
						const activeChat = this.$store.state.chatStore.chats[chatIndex];

						// 生成统一会话ID
						const unifiedSessionId = `vue-im-${user.id}`;

						// 获取统一会话服务
						const unifiedSessionService = window.vscodeServices.get('IUnifiedSessionService');
						if (unifiedSessionService) {
							// 检查会话是否已存在
							const sessionExists = unifiedSessionService.getAllSessions &&
								unifiedSessionService.getAllSessions().some(s => s.id === unifiedSessionId);

							if (!sessionExists && unifiedSessionService.syncVueSessionsFromWebView) {
								console.log("[InboxFriend] 会话不存在，进行增量同步...");
								// 同步单个会话到统一服务
								const sessionData = {
									id: user.id,
									sessionId: user.id,
									showName: user.nickName,
									type: 'vue-im',
									headImage: user.headImageThumb || user.headImage,
									lastSendTime: Date.now(),
									messages: activeChat?.messages || []
								};

								await unifiedSessionService.syncVueSessionsFromWebView([sessionData]);
								console.log("[InboxFriend] 会话已同步到统一服务");
							}

							// 激活统一会话
							if (unifiedSessionService.setActiveSession) {
								unifiedSessionService.setActiveSession(unifiedSessionId);
								console.log("[InboxFriend] 已激活统一会话:", unifiedSessionId);
							}
						}

						// 使用面板管理服务打开编辑器
						const panelManagerService = window.vscodeServices.get('panelManagerService');
						if (panelManagerService && panelManagerService.openChatEditor) {
							const chatUser = {
								id: user.id,
								nickName: user.nickName,
								name: user.nickName,
								headImage: user.headImageThumb || user.headImage,
								headImageThumb: user.headImageThumb || user.headImage,
								avatar: user.headImage,
							};
							panelManagerService.openChatEditor(chatUser);

							this.$store.commit("changeViewCode", 1);// 切换到聊天页面
							console.log("[InboxFriend] ✅ 聊天编辑器面板已打开:", user.nickName);
						} else {
							console.warn("[InboxFriend] ⚠️ PanelManagerService或openChatEditor方法不可用");
						}
					} catch (error) {
						console.error('[InboxFriend] VSCode环境处理失败:', error);
					}
				} else {
					// Web环境，使用路由跳转
					this.$router.push("/home/chat");
				}
			}
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$store.commit('showFullImageBox', this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		friendStore() {
			return this.$store.state.friendStore;
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted || (this.searchText && !f.nickName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(f.nickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	},
	mounted() {
		console.log('[InboxFriend] Component mounted!');
		console.log('[InboxFriend] window.SharedServicesAccessor available on mount:', !!window.SharedServicesAccessor);
		console.log('[InboxFriend] window object keys:', Object.keys(window));
	}
}
</script>

<style lang="scss">
.friend-page {
	height: 100% !important;
	
	// 重写Element UI的el-container样式
	
	
	.friend-list-box {
		height: 100% !important;
		
		// 重写Element UI的el-aside样式
		&.el-aside {
			height: 100% !important;
		}
		
		display: flex;
		flex-direction: column;
		background: var(--im-background);

		.friend-list-header {
			height: 50px;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			padding: 0 8px;

			.add-btn {
				padding: 5px !important;
				margin: 5px;
				font-size: 16px;
				border-radius: 50%;
			}
		}

		.friend-list-items {
			flex: 1;
			height: 0; // 强制flex子元素高度计算

			.index-title {
				text-align: left;
				font-size: var(--im-larger-size-larger);
				padding: 5px 15px;
				color: var(--im-text-color-light);
			}
		}
	}

	.friend-box {
		display: flex;
		flex-direction: column;

		.friend-header {
			height: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 12px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
			box-sizing: border-box;
		}

		.friend-detail {
			display: flex;
			padding: 50px 80px 20px 80px;
			text-align: center;

			.info-item {
				margin-left: 20px;
				background-color: #ffffff;
				border: 1px #ddd solid;
			}

			.description {
				padding: 20px 20px 0 20px;
			}
		}

		.frient-btn-group {
			text-align: left !important;
			padding: 20px;
		}
	}
}
</style>